import React from "react";
import "./style.scss";
import StatisticsCard from "./components/StatisticsCard/StatisticsCard";
import useStore from "../../store";
import Loader from "../../../common/ui/loader/Loader";
import { TopDevicesTable } from "./TopDevicesTable";
import TotalInfoCard from "../../../common/ui/totalInfoCard/TotalInfoCard";
import Icon from "../../../common/ui/Icon";
import TextTitle from "../../../common/ui/typography/TextTitle";

interface CompaniesStatisticsProps {
  statisticType: string;
}

const CompaniesStatistics: React.FC<CompaniesStatisticsProps> = ({
  statisticType,
}) => {
  const dataMap: { [key: string]: any } = {
    company: useStore((state) => state.companyData),
    subscription: useStore((state) => state.subscriptionData),
    vehicle: useStore((state) => state.vehicleData),
    vehicle_stats: useStore((state) => state.vehicleStatsData),
    user: useStore((state) => state.userData),
    driver: useStore((state) => state.driverData),
    driver_stats: useStore((state) => state.driverStatsData),
    device: useStore((state) => state.deviceData),
    all: useStore((state) => state.vehicleStatsData),
  };
  const companyTotals = useStore((state) => state.companyTotals);

  const data = dataMap[statisticType];
  const data_stats = dataMap[`${statisticType}_stats`];

  return (
    <div
      style={{ position: "relative", minHeight: "400px", gap: "24px" }}
      className="d-flex flex-column"
    >
      {statisticType === "all" ? (
        !companyTotals ? (
          <div
            className="d-flex flex-column"
            style={{ margin: "72px auto 0 auto" }}
          >
            <Icon icon="empty-company" size={"220px"} />
            <TextTitle level="3" className="text-center">
              Select a company to display <br /> their statistics here.
            </TextTitle>
          </div>
        ) : dataMap.vehicle_stats ? (
          <>
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
              {companyTotals?.map((el) => (
                <TotalInfoCard amount={el.total} title={el.title} />
              ))}
            </div>
            <StatisticsCard
              title={dataMap.subscription.title}
              header={dataMap.subscription.header}
              cards={dataMap.subscription.cards}
              chart={dataMap.subscription.chart}
              hideTotal
            />
            <StatisticsCard
              title={dataMap.driver_stats.title}
              header={dataMap.driver_stats.header}
              cards={dataMap.driver_stats.cards}
              chart={dataMap.driver_stats.chart}
              hideTotal
            />
            <StatisticsCard
              title={dataMap.vehicle_stats.title}
              header={dataMap.vehicle_stats.header}
              cards={dataMap.vehicle_stats.cards}
              chart={dataMap.vehicle_stats.chart}
              hideTotal
            />
          </>
        ) : (
          <Loader />
        )
      ) : (
        <>
          {data ? (
            <>
              <StatisticsCard
                title={data.title}
                header={data.header}
                cards={data.cards}
                chart={data.chart}
              />
              {data_stats ? (
                <StatisticsCard
                  title={data_stats.title}
                  header={data_stats.header}
                  cards={data_stats.cards}
                  chart={data_stats.chart}
                />
              ) : (
                <></>
              )}
            </>
          ) : (
            <Loader />
          )}
        </>
      )}

      {statisticType === "device" && data && (
        <div className="d-flex gap-3 flex-wrap mt-4">
          <TopDevicesTable
            OSType="ANDROID"
            statisticType="app_version"
            title="Android app versions"
          />
          <TopDevicesTable
            OSType="IOS"
            statisticType="app_version"
            title="IOS app versions"
          />
          <TopDevicesTable
            OSType="ANDROID"
            statisticType="model"
            title="Android app models"
          />
          <TopDevicesTable
            OSType="IOS"
            statisticType="model"
            title="IOS app models"
          />
        </div>
      )}
    </div>
  );
};

export default CompaniesStatistics;
